module.exports = __webpack_public_path__ + "static/media/randomlo2.0e34e81b.jpg";